module.exports = __webpack_public_path__ + "static/media/London.6c9e1f02.jpg";